import {api, headers} from './api';

const RESOURCE = 'lembaga_jabatan';

export const userLembagaJabatan = (users_id) => api.get(RESOURCE+'/'+users_id, headers);

export const storeLembagaJabatan = (data) => api.post(RESOURCE, data, headers);